import { Box, Divider, Grid, List, ListItem, Typography } from "@mui/material";
import { FC } from "react";
import { Employer, InvitedEmployee, Plan, PlanReference } from "../../models";
import { formatCurrency } from "../../utils/formatters";
import { FundSummary } from "./FundSummary";

export const Step4SetupFund: FC<{
  employer: Employer | undefined;
  next: () => void;
  back: () => void;
  minimumFund: number;
  invitedEmployees: InvitedEmployee[];
  adminEmployeePlanReference: PlanReference | undefined;
  plans: Plan[];
}> = ({
  employer,
  next,
  back,
  minimumFund,
  invitedEmployees,
  adminEmployeePlanReference,
  plans
}) => {
  //TODO: This needs to be rebuilt to work with new funding float (prev. float)

  return (
    <Grid container item>
      <Grid item xs={8}>
        <Typography variant="h4" fontSize={32} fontWeight={700}>
          Add funds to your account
        </Typography>

        <Typography mt={4} mb={2} fontWeight={600}>
          How deposits work
        </Typography>

        <Divider sx={{ borderWidth: 1 }} />
        <List dense={true}>
          <ListItem>
            <Typography fontSize={15}>
              • We secure 10% of your total contribution to cover your users
              transactions
            </Typography>
          </ListItem>
          <ListItem>
            <Typography fontSize={15}>
              • Paying your monthly invoices will replenish your account funds
            </Typography>
          </ListItem>
          <ListItem>
            <Typography fontSize={15}>
              • If your funds are depleted we will prompt you to make another
              payment
            </Typography>
          </ListItem>
          <ListItem>
            <Typography fontSize={15}>
              • You will never be charged more than your set users allowances
              giving you total peace of mind
            </Typography>
          </ListItem>
        </List>

        <Divider sx={{ borderWidth: 1 }} />

        <Box display="flex" my={2}>
          <Typography fontWeight={600}>Deposit due today</Typography>
          <Typography ml={1}>(10% of total contribution)</Typography>
          <Typography ml="auto" color="primary">
            {formatCurrency(minimumFund)}
          </Typography>
        </Box>

        {/* <Divider sx={{ borderWidth: 1 }} />
        <Box my={2} mt={3}>
          <Typography fontWeight={600}>Card Details</Typography>
        </Box>

        {paid && <Typography fontWeight={600}>Successfully Paid</Typography>}

        {!paid && (
          <>
            { {invoice ? (
              <CardPayment
                invoiceId={invoice.id}
                amount={invoice.amount}
                onSuccess={next}
                countryId={employer?.country.id ?? ""}
              >
                <BackButton onClick={back} outlined />
              </CardPayment>
            ) : (
              <LoadingSpinner marginY="10" />
            )} }
          </>
        )}

        {error && (
          <Typography color="error" mt={3}>
            {error}
          </Typography>
        )} */}
      </Grid>

      <Grid
        item
        xs={3}
        sx={{
          flexDirection: "column",
          gap: 3,
          marginLeft: "auto",
          marginTop: -14
        }}
        display={{ xs: "none", md: "none", lg: "flex" }}
      >
        <FundSummary
          invitedEmployees={invitedEmployees}
          adminEmployeePlanReference={adminEmployeePlanReference}
          plans={plans}
        />
      </Grid>
    </Grid>
  );
};
